// extracted by mini-css-extract-plugin
export const sectionInverseSlider = "inverseSlider-module--sectionInverseSlider--hnwFh";
export const sectionBackground = "inverseSlider-module--sectionBackground--Uk2jM";
export const sectionContent = "inverseSlider-module--sectionContent--1WJwg";
export const sectionContainer = "inverseSlider-module--sectionContainer--20ajk";
export const sectionHeading = "inverseSlider-module--sectionHeading--29Gry";
export const sliderWrap = "inverseSlider-module--sliderWrap--30033";
export const inverseSlideItem = "inverseSlider-module--inverseSlideItem--3XXQv";
export const slideItemWrap = "inverseSlider-module--slideItemWrap--1yqoC";
export const mobileImageWrap = "inverseSlider-module--mobileImageWrap--7N2Mh";
export const siImageWrap = "inverseSlider-module--siImageWrap--3RW2g";
export const appStore = "inverseSlider-module--appStore--2Zx2K";
export const googlePlay = "inverseSlider-module--googlePlay--3KUNm";
export const congratsTab = "inverseSlider-module--congratsTab--3BeSS";
export const domainTab = "inverseSlider-module--domainTab--3vM7v";
export const downloadLinks = "inverseSlider-module--downloadLinks--k_ytu";
export const siBulletContent = "inverseSlider-module--siBulletContent--1wozM";
export const siBullet = "inverseSlider-module--siBullet--17n7n";
export const richtext = "inverseSlider-module--richtext--un9QD";
export const siContentWrap = "inverseSlider-module--siContentWrap--2fG3d";
export const ctalink = "inverseSlider-module--ctalink--BjuXP";
export const mobileSlides = "inverseSlider-module--mobileSlides--2AGrU";
export const mobileSlideItem = "inverseSlider-module--mobileSlideItem--27KUq";
export const msiImageWrap = "inverseSlider-module--msiImageWrap--J333j";
export const msiBulletContent = "inverseSlider-module--msiBulletContent--1fwLa";
export const msiBullet = "inverseSlider-module--msiBullet--1DXNp";
export const msiSectionCTA = "inverseSlider-module--msiSectionCTA--FtaxW";
export const mobilectalink = "inverseSlider-module--mobilectalink--2zhzj";